import React from "react";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import { Button } from "antd";
import { themeColor, project } from "@/config.json";

interface StoreProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

interface CommonButtonProp {
  onClick: any;
  text: any;
  style?: any;
  className?: any;
  color?: any;
  colorType?: "default" | "green" | "red" | "yellow";
  disabled?: boolean;
  type?: "primary" | "link" | "dashed";
  size?: "large" | "middle" | "small";
}

interface Props extends StoreProps, CommonButtonProp {}

@inject("session", "locale", "router")
@observer
class CommonButton extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  state = {
    color: themeColor,
    bgColor: this.props.colorType ? "#fff4f6" : "#ECF0FD", //"transparent",
    borderColor: themeColor,
  };
  componentDidMount() {
    this.setState({
      color: this.props.color,
      bgColor: this.props.colorType ? "#fff4f6" : "#ECF0FD", //"transparent",
      // borderColor: this.props.color,
    });
  }

  onMouseOver = () => {
    this.setState({
      color: "#fff",
      bgColor: this.props.color ? this.props.color : themeColor,
      borderColor: this.props.color ? this.props.color : themeColor,
    });
  };

  onMouseOut = () => {
    this.setState({
      color: this.props.color ? this.props.color : themeColor,
      bgColor: this.props.colorType ? "#fff4f6" : "#ECF0FD", //"transparent",
      borderColor: this.props.color ? this.props.color : themeColor,
    });
  };

  render() {
    const { color, bgColor, borderColor } = this.state;
    const {
      onClick,
      text,
      className,
      colorType = "default",
      disabled,
      type,
      style,
      size,
    } = this.props;

    return (
      <Button
        style={{
          color: color,
          backgroundColor: bgColor,
          borderColor: bgColor,
          ...style,
        }}
        onClick={onClick}
        disabled={disabled}
        type={type}
        size={size}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        className={`common-button ${className} ${project}-button ${colorType} common-button-${size}`}
      >
        {text}
      </Button>
    );
  }
}

export default CommonButton as React.ComponentType<CommonButtonProp>;
